import React, { Fragment } from 'react';
import {
  MOBILE_DISPLAY_NEW_APP_DOWNLOAD_PROMPT_CTA,
  MOBILE_DISPLAY_UPLOAD_PHOTOS_CTA,
  MOBILE_DISPLAY_SHOW_ADD_BUTTON,
  MOBILE_DISPLAY_LEGACY_CTA,
} from '../../store/modules/product';

export const MobileAvailabilityDisplay = ({
  displayState,
} : {
    displayState: 1 | 2 | 3 | 4,
}) => {
  let output = null;

  switch (displayState) {
    case MOBILE_DISPLAY_UPLOAD_PHOTOS_CTA:
      output = (
        <div id="au-mobile-product" className="no-app-no-mobile">
          <a href="/account/mobile/index/">
            <div className="mobile-availability">
              <h4 className="mobile-availability__headline">Upload Your Photos</h4>
              <div className="mobile-availability__icon">
                <img src="https://assets.artifactuprising.com/assets/images/icons/upload-images-icon.svg" alt="" />
              </div>
              <p>This product is not currently available to customize on your mobile device. However, you can get a head start by uploading photos from your camera roll here. Then, return to this site on your desktop or laptop computer to continue creating!</p>
            </div>
          </a>
        </div>
      );
      break;

    case MOBILE_DISPLAY_NEW_APP_DOWNLOAD_PROMPT_CTA:
      output = (
        <div id="au-mobile-product" className="yes-app-no-mobile">
          <div className="mobile-availability">
            <p>This product is not yet available for customization within a mobile browser.</p>
            <div className="mobile-availability__icon">
              <a href="https://itunes.apple.com/us/app/artifact-uprising-photo-books-prints-cards/id713083894?mt=8">
                <img className="mobile-availability__icon-app" src="https://assets.artifactuprising.com/assets/images/icons/au-app-icon.png" alt="" />
              </a>
            </div>
            <p>Download the Artifact Uprising App to get started.</p>
            <div className="mobile-availability__icon">
              <a href="https://itunes.apple.com/us/app/artifact-uprising-photo-books-prints-cards/id713083894?mt=8">
                <img className="mobile-availability__icon-appstore" src="https://assets.artifactuprising.com/assets/images/appstore.jpg" alt="Download on the app store" />
              </a>
            </div>
          </div>
        </div>
      );
      break;

    // Display everything as it is on desktop
    case MOBILE_DISPLAY_SHOW_ADD_BUTTON:
      return null;

    case MOBILE_DISPLAY_LEGACY_CTA:
      output = (
        <Fragment>
          <p className="txt-bdy-1 text-center">This product has been optimized for desktop – please head to your computer to get started. For mobile-friendly products, download the AU App in the App Store.</p>
          <a href="https://itunes.apple.com/us/app/artifact-uprising-photo-books-prints-cards/id713083894?mt=8">
            <img src="https://assets.artifactuprising.com/assets/images/appstore.jpg" width="149" height="43" alt="" />
          </a>
        </Fragment>
      );
      break;

    default:
      return null;
  }

  return (
    <div className="au-mobile-only text-center bg-gray--light">
      { output }
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/MobileAvailability/index.js